var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecuriter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C17.8262 7 18.623 7.10547 19.3906 7.31641C20.1582 7.52734 20.873 7.83203 21.5352 8.23047C22.1973 8.62891 22.8037 9.09766 23.3545 9.63672C23.9053 10.1758 24.377 10.7822 24.7695 11.4561C25.1621 12.1299 25.4639 12.8477 25.6748 13.6094C25.8857 14.3711 25.9941 15.168 26 16C26 16.8262 25.8945 17.623 25.6836 18.3906C25.4727 19.1582 25.168 19.873 24.7695 20.5352C24.3711 21.1973 23.9023 21.8037 23.3633 22.3545C22.8242 22.9053 22.2178 23.377 21.5439 23.7695C20.8701 24.1621 20.1523 24.4639 19.3906 24.6748C18.6289 24.8857 17.832 24.9941 17 25C16.1738 25 15.377 24.8945 14.6094 24.6836C13.8418 24.4727 13.127 24.168 12.4648 23.7695C11.8027 23.3711 11.1963 22.9023 10.6455 22.3633C10.0947 21.8242 9.62305 21.2178 9.23047 20.5439C8.83789 19.8701 8.53613 19.1523 8.3252 18.3906C8.11426 17.6289 8.00586 16.832 8 16C8 15.1738 8.10547 14.377 8.31641 13.6094C8.52734 12.8418 8.83203 12.127 9.23047 11.4648C9.62891 10.8027 10.0977 10.1963 10.6367 9.64551C11.1758 9.09473 11.7822 8.62305 12.4561 8.23047C13.1299 7.83789 13.8477 7.53613 14.6094 7.3252C15.3711 7.11426 16.168 7.00586 17 7ZM21.5 16H17V10.375H15.875V17.125H21.5V16Z",
    fill: "#57D5CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecuriter);
export default __webpack_public_path__ + "static/media/recuriter.3942ac58e156c146ab8d697690d7b525.svg";
export { ForwardRef as ReactComponent };